import * as React from 'react';
//import { default as Transition } from 'react-transition-group/Transition'; // TODO: when the definition file is fixed
const Transition = require('react-transition-group/Transition').default;

export type OffsetAndOpacity = {
    x?: string;
    y?: string;
    opacity?: number;
};

export type Props = {
    visible: boolean;
    duration: number | { enter?: number; exit?: number };
    children: React.ReactNode;
    from: OffsetAndOpacity;
    to: OffsetAndOpacity;
    transformOrigin?: string;
    className?: string;
    unmountOnExit?: boolean;
};

type TransitionState = 'entering' | 'entered' | 'exiting' | 'exited';

const getStyle = (state: TransitionState, from: OffsetAndOpacity, to: OffsetAndOpacity) => {
    const isIn = state === 'entering' || state === 'entered';
    const x = (isIn ? to.x : from.x) || '0';
    const y = (isIn ? to.y : from.y) || '0';
    const opacity = (isIn ? to.opacity : from.opacity);
    const defaultOpacity = isIn ? 1 : 0;
    return {
        opacity: typeof opacity === 'number' ? opacity : defaultOpacity,
        transform: `translate(${x},${y})`,
    };
};

export const FadeTranslate = ({ visible, duration, children, from, to, className, transformOrigin, unmountOnExit }: Props) => {
    const durationIn = typeof duration === 'number' ? duration : duration.enter;
    const durationOut = typeof duration === 'number' ? duration : duration.exit;
    return (
        <Transition in={ visible } timeout={ duration }>
            { (state: TransitionState) =>
                <div
                    className={ className }
                    style={ {
                        transition: `all ${state === 'entering' || state === 'entered' ? durationIn : durationOut}ms ease-out`,
                        transformOrigin,
                        ...getStyle(state, from, to),
                    } }
                >
                    { state === 'exited' && unmountOnExit ? null : children }
                </div>
            }
        </Transition>
    );
};



// WEBPACK FOOTER //
// ./src/ui/transitions/FadeTranslate.tsx